import React from "react";
import { Link } from "react-router-dom";
import { ChevronLeft, Home } from "lucide-react";
import { useLanguage } from "../../i18n/LanguageContext";

const PublicPageHero = ({ eyebrow, title, description, children }) => {
  const { isEnglish, direction } = useLanguage();
  return (
  <section className="public-hero" dir={direction}>
    <div className="public-container">
      <div className="public-breadcrumb"><Link to="/"><Home size={14} /> {isEnglish ? "Home" : "خانه"}</Link><ChevronLeft size={14} /><span>{title}</span></div>
      {eyebrow && <small>{eyebrow}</small>}
      <h1>{title}</h1>
      {description && <p>{description}</p>}
      {children}
    </div>
  </section>
  );
};

export default PublicPageHero;
